"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Tariff extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'tariff';
        this._name = initParams.name;
        this._currency = initParams.currency;
        this._utilityType = initParams.utility_type;
        this._organisationId = initParams.organisation_id;
        this._standingCharge = initParams.standing_charge;
        this._rates = (0, util_1.camelArray)(initParams.rates);
        this._contractStart = initParams.contract_start;
        this._contractEnd = initParams.contract_end;
        this._billingCycleType = initParams.billing_cycle_type;
        this._billingCycleStartDay = initParams.billing_cycle_start_day;
        this._applyContractRange = initParams.apply_contract_range;
        this._applyBillingCycle = initParams.apply_billing_cycle;
        this._siteId = initParams.site_id;
        this._siteIds = (0, util_1.camelArray)(initParams.site_ids);
        this.__permission = initParams._permission;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateTariff(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set currency(value) {
        console.error('Do not set objects this way');
    }
    setCurrency(value) {
        return this.dataService.updateTariff(this.id, { currency: value }, this);
    }
    get currency() {
        return this._currency;
    }
    set utilityType(value) {
        console.error('Do not set objects this way');
    }
    setUtilityType(value) {
        return this.dataService.updateTariff(this.id, { utility_type: value }, this);
    }
    get utilityType() {
        return this._utilityType;
    }
    set organisationId(value) {
        console.error('Do not set objects this way');
    }
    setOrganisationId(value) {
        return this.dataService.updateTariff(this.id, { organisation_id: value }, this);
    }
    get organisationId() {
        return this._organisationId;
    }
    set standingCharge(value) {
        console.error('Do not set objects this way');
    }
    setStandingCharge(value) {
        return this.dataService.updateTariff(this.id, { standing_charge: value }, this);
    }
    get standingCharge() {
        return this._standingCharge;
    }
    set rates(value) {
        console.error('Do not set objects this way');
    }
    setRates(value) {
        return this.dataService.updateTariff(this.id, { rates: (0, util_1.snakeArray)(value) }, this);
    }
    get rates() {
        return this._rates;
    }
    set contractStart(value) {
        console.error('Do not set objects this way');
    }
    setContractStart(value) {
        return this.dataService.updateTariff(this.id, { contract_start: value }, this);
    }
    get contractStart() {
        return this._contractStart;
    }
    set contractEnd(value) {
        console.error('Do not set objects this way');
    }
    setContractEnd(value) {
        return this.dataService.updateTariff(this.id, { contract_end: value }, this);
    }
    get contractEnd() {
        return this._contractEnd;
    }
    set billingCycleType(value) {
        console.error('Do not set objects this way');
    }
    setBillingCycleType(value) {
        return this.dataService.updateTariff(this.id, { billing_cycle_type: value }, this);
    }
    get billingCycleType() {
        return this._billingCycleType;
    }
    set billingCycleStartDay(value) {
        console.error('Do not set objects this way');
    }
    setBillingCycleStartDay(value) {
        return this.dataService.updateTariff(this.id, { billing_cycle_start_day: value }, this);
    }
    get billingCycleStartDay() {
        return this._billingCycleStartDay;
    }
    set applyContractRange(value) {
        console.error('Do not set objects this way');
    }
    setApplyContractRange(value) {
        return this.dataService.updateTariff(this.id, { apply_contract_range: value }, this);
    }
    get applyContractRange() {
        return this._applyContractRange;
    }
    set applyBillingCycle(value) {
        console.error('Do not set objects this way');
    }
    setApplyBillingCycle(value) {
        return this.dataService.updateTariff(this.id, { apply_billing_cycle: value }, this);
    }
    get applyBillingCycle() {
        return this._applyBillingCycle;
    }
    set siteId(value) {
        console.error('Do not set objects this way');
    }
    setSiteId(value) {
        return this.dataService.updateTariff(this.id, { site_id: value }, this);
    }
    get siteId() {
        return this._siteId;
    }
    set siteIds(value) {
        console.error('Do not set objects this way');
    }
    setSiteIds(value) {
        return this.dataService.updateTariff(this.id, { site_ids: (0, util_1.snakeArray)(value) }, this);
    }
    get siteIds() {
        return this._siteIds;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateTariff(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateTariff(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteTariff(this.id, this);
    }
}
exports.default = Tariff;
//# sourceMappingURL=tariff.js.map